var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 40,
    viewBox: "0 0 98 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1332_5122)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1332_5122",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 13,
    width: 70,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.5406 13H14.8105V26.196H83.5406V13Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1332_5122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.1265 25.51L41.9085 22.245H36.2125L34.9945 25.511H32.9345L37.7545 13.02H40.4045L45.2055 25.51H43.1265ZM36.8575 20.568H41.2815L39.8135 16.643L39.0785 14.483L38.3265 16.643L36.8575 20.568ZM51.3305 16.785C51.7065 16.785 52.0825 16.803 52.3505 16.928V18.695C52.1005 18.587 51.8315 18.48 51.1875 18.48C49.5575 18.48 48.6615 19.783 48.6615 21.8V25.51H46.8345V16.947H48.6615V19.445C48.9305 18.071 49.6115 16.785 51.3305 16.785ZM58.5895 16.786C58.9655 16.786 59.3415 16.804 59.6105 16.929V18.696C59.3605 18.588 59.0905 18.481 58.4465 18.481C56.8165 18.481 55.9205 19.784 55.9205 21.801V25.511H54.0935V16.947H55.9205V19.445C56.1895 18.071 56.8705 16.786 58.5895 16.786ZM64.7835 16.769C67.2915 16.769 69.3155 18.517 69.3155 21.229C69.3155 23.941 67.2915 25.689 64.7835 25.689C62.2935 25.689 60.2705 23.941 60.2705 21.229C60.2705 18.517 62.2945 16.769 64.7835 16.769ZM64.7835 24.031C66.6835 24.031 67.4705 23.228 67.4705 21.229C67.4705 19.231 66.6825 18.428 64.7835 18.428C62.8845 18.428 62.1155 19.231 62.1155 21.229C62.1155 23.227 62.8855 24.031 64.7835 24.031ZM81.5005 16.946H83.4885L81.0165 25.511H78.9566L77.2365 20.604L76.7715 18.998L76.2885 20.622L74.5505 25.511H72.5085L70.0185 16.946H72.0245L73.2965 22.156L73.6365 23.905L74.1385 22.156L75.8225 16.946H77.6855L79.3685 22.138L79.8705 23.94L80.2285 22.156L81.5005 16.946ZM19.1115 14.885H25.9075C26.0495 14.885 26.1655 15 26.1655 15.142V21.912L21.8645 26.196V19.183H14.8105L19.1115 14.885Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1332_5122"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 69,
    height: 14,
    fill: "white",
    transform: "translate(14.8105 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/Arrow.ac4cebff441386454af11b1abb57c2fd.svg";
export { ForwardRef as ReactComponent };